import { render } from "./EmployeeDataImport.vue?vue&type=template&id=ad061e70&scoped=true"
import script from "./EmployeeDataImport.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImport.vue?vue&type=script&lang=js"

import "./EmployeeDataImport.vue?vue&type=style&index=0&id=ad061e70&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad061e70"]])

export default __exports__